import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { LuxFwTextBox, LuxFwComboBox } from 'luxFw/palettes/Standart';
import { LuxFwDatePicker } from 'luxFw/palettes/DateTime';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import { onChangeValue, onChangeCombo, onChangeDate } from 'actions/Global';
import {
    buscaDiario,
    listaCursosDiario,
    listaSeriesDiario,
    listaTurmasDiario,
    limparDiario
} from 'actions/Diario';
import IntlMessages from 'util/IntlMessages';
import moment from 'moment';

class FormDiario extends Component {

    componentDidMount() {
        // Set default date to today if not set
        if (!this.props.data) {
            this.props.onChangeDate('data', moment().format('DD/MM/YYYY'));
        }
    }

    handleAnoLetivoChange = (e) => {
        this.props.onChangeValue(e);
        this.limparCamposDependentes(['escolaId', 'cursoId', 'serieId', 'turmaId']);
    };

    handleEscolaChange = (name, object, value) => {
        this.props.onChangeCombo(name, object, value);
        const escolaId = this.getIdValue(value);
        const { anoLetivo } = this.props;
        this.limparCamposDependentes(['cursoId', 'serieId', 'turmaId']);
        if (escolaId && anoLetivo) {
            this.props.listaCursosDiario(escolaId, anoLetivo);
        }
    };

    handleCursoChange = (name, object, value) => {
        this.props.onChangeCombo(name, object, value);
        const cursoId = this.getIdValue(value);
        this.limparCamposDependentes(['serieId', 'turmaId']);
        if (cursoId) {
            this.props.listaSeriesDiario(cursoId);
        }
    };

    handleSerieChange = (name, object, value) => {
        this.props.onChangeCombo(name, object, value);
        const serieId = this.getIdValue(value);
        const escolaId = this.getIdValue(this.props.escolaId);
        const { anoLetivo } = this.props;
        this.limparCamposDependentes(['turmaId']);
        if (serieId && escolaId && anoLetivo) {
            this.props.listaTurmasDiario(anoLetivo, escolaId, serieId);
        }
    };

    handleTurmaChange = (name, object, value) => {
        this.props.onChangeCombo(name, object, value);
    };

    getIdValue = (value) => {
        if (!value) return null;
        if (typeof value === 'object') return value.id !== undefined ? value.id : (value.value !== undefined ? value.value : null);
        return value;
    };

    limparCamposDependentes = (campos) => {
        campos.forEach(campo => this.props.onChangeCombo(campo, null, null));
    };

    handleBuscar = () => {
        const filtros = {
            anoLetivo: this.props.anoLetivo,
            escolaId: this.getIdValue(this.props.escolaId),
            cursoId: this.getIdValue(this.props.cursoId),
            serieId: this.getIdValue(this.props.serieId),
            turmaId: this.getIdValue(this.props.turmaId),
            data: moment(this.props.data, 'DD/MM/YYYY').format('YYYY-MM-DD')
        };
        this.props.buscaDiario(filtros);
    };

    handlePreencherLocal = () => {
        const filtros = {
            anoLetivo: '2025',
            turmaId: 4,

        };

        this.props.onChangeValue({ target: { name: 'anoLetivo', value: '2025' } });
        this.props.onChangeCombo('turmaId', null, { id: 18 });

        this.props.buscaDiario(filtros);
    };

    isFormValido = () => {
        const { anoLetivo, escolaId, cursoId, serieId, turmaId, data } = this.props;
        return !!(anoLetivo && this.getIdValue(escolaId) && this.getIdValue(cursoId) &&
            this.getIdValue(serieId) && this.getIdValue(turmaId) && data);
    };

    render() {
        const validador = { obrigatorio: true };
        const {
            anoLetivo, escolaId, cursoId, serieId, turmaId, data,
            listaEscolas, listaCursos, listaSeries, listaTurmas,
            cursosCarregados, seriesCarregadas, turmasCarregadas
        } = this.props;

        const cursoHab = !!(anoLetivo && this.getIdValue(escolaId));
        const serieHab = !!this.getIdValue(cursoId);
        const turmaHab = !!this.getIdValue(serieId);

        return (
            <Fragment>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <Grid container spacing={1} alignItems="flex-start">
                                            <Grid item xs={12} md={4}>
                                                <LuxFwTextBox
                                                    validador={{ anoLetivo: validador }}
                                                    name="anoLetivo"
                                                    label={<IntlMessages id="diario.campo.anoLetivo" defaultMessage="Ano Letivo" />}
                                                    tamanho="12"
                                                    tipo="number"
                                                    valor={anoLetivo}
                                                    onChange={this.handleAnoLetivoChange}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <LuxFwComboBox
                                                    validador={{ escolaId: validador }}
                                                    name="escolaId"
                                                    label={<IntlMessages id="diario.campo.escola" defaultMessage="Escola" />}
                                                    tamanho="12"
                                                    lista={listaEscolas}
                                                    valor={escolaId}
                                                    onChange={this.handleEscolaChange}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <LuxFwComboBox
                                                    validador={{ cursoId: validador }}
                                                    name="cursoId"
                                                    label={<IntlMessages id="diario.campo.curso" defaultMessage="Curso" />}
                                                    tamanho="12"
                                                    lista={listaCursos}
                                                    valor={cursoId}
                                                    onChange={this.handleCursoChange}
                                                    desabilitado={!cursoHab ? 'true' : 'false'}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <LuxFwComboBox
                                                    validador={{ serieId: validador }}
                                                    name="serieId"
                                                    label={<IntlMessages id="diario.campo.serie" defaultMessage="Série" />}
                                                    tamanho="12"
                                                    lista={listaSeries}
                                                    valor={serieId}
                                                    onChange={this.handleSerieChange}
                                                    desabilitado={!serieHab ? 'true' : 'false'}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <LuxFwComboBox
                                                    validador={{ turmaId: validador }}
                                                    name="turmaId"
                                                    label={<IntlMessages id="diario.campo.turma" defaultMessage="Turma" />}
                                                    tamanho="12"
                                                    lista={listaTurmas}
                                                    valor={turmaId}
                                                    onChange={this.handleTurmaChange}
                                                    desabilitado={!turmaHab ? 'true' : 'false'}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <LuxFwDatePicker
                                                    name="data"
                                                    label={<IntlMessages id="diario.campo.data" defaultMessage="Data" />}
                                                    tamanho="12"
                                                    valor={data}
                                                    onChange={this.props.onChangeDate}
                                                    disableFuture={true}
                                                />
                                            </Grid>
                                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8, padding: '0px 20px' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<SearchIcon />}
                                            onClick={this.handleBuscar}
                                            disabled={!this.isFormValido()}
                                            style={{ marginBottom: 0, padding: '10px 30px', borderRadius: 100 }}
                                        >
                                            <span style={{ fontStyle: 'normal', color: '#ffffff', fontFamily: 'Montserrat, sans-serif', fontSize: '14px', letterSpacing: '1.25px', textTransform: 'none' }}>
                                                <IntlMessages id="diario.botao.buscar" defaultMessage="Abrir Diário" />
                                            </span>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ diario }) => ({ ...diario });

export default connect(mapStateToProps, {
    onChangeValue,
    onChangeCombo,
    onChangeDate,
    buscaDiario,
    listaCursosDiario,
    listaSeriesDiario,
    listaTurmasDiario,
    limparDiario
})(FormDiario);
